import {
    Stack
} from "@mui/material";

import NothingSelected from "./NothingSelected";
import Host from "../Host";
import User from "../User";

const Content = ({ content=null }) => {

    const renderContent = () => {
        
        if (content) {
            switch(content.object_type) {
                case 'user': {
                    const object = content.object.split(":")
                    return <User billingId={object[0]} userId={object[1]} />
                }
                case 'host': 
                    const object = content.object.split(":")
                    return <Host networkId={object[0]} hostIp={object[1]} />;
                default: 
                    return (
                        <>
                            <Stack
                                sx={{ height: "100%", width: "100%" }}
                                alignItems="center"
                                justifyContent={"center"}
                            >
                                <NothingSelected/>
                            </Stack>
                        </>
                    );
                }
        }
        // else {
        //     return (
        //         <>
        //             <Stack
        //                 sx={{ height: "100%", width: "100%" }}
        //                 alignItems="center"
        //                 justifyContent={"center"}
        //             >
        //                 <NothingSelected/>
        //             </Stack>
        //         </>
        //     );
            
        // }
    }

    return (
        <>
            {renderContent()}
        </>
    );
};

export default Content;